export const currencyFormatter = (value, currency) => {
  let formattedValue = value || value === 0 ? value : 0;

  if (value < 0) {
    formattedValue = Math.abs(value);
  }

  formattedValue = formattedValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

  if (formattedValue.endsWith('.00')) {
    formattedValue = formattedValue.replace('.00', '');
  }

  if (value < 0) {
    switch (currency) {
      case 0: // USD
        return `$(${formattedValue})`;
      case 1: // EUR
        return `-${formattedValue} €`;
      case 2: // GBP
        return `-£${formattedValue}`;
      case 3: // AUD
        return `-$${formattedValue}`;
      case 4: // BRL
        return `-R$ ${formattedValue}`;
      case 5: // SGD
        return `-S$ ${formattedValue}`;
      case 6: // CHF
        return `CHF-${formattedValue}`;
      case 7: // CNY
        return `¥-${formattedValue}`;
      case 8: // SEK
        return `-${formattedValue} kr`;
      default:
        return `($${formattedValue})`;
    }
  } else {
    switch (currency) {
      case 0: // USD
        return `$${formattedValue}`;
      case 1: // EUR
        return `${formattedValue} €`;
      case 2: // GBP
        return `£${formattedValue}`;
      case 3: // AUD
        return `$${formattedValue}`;
      case 4: // BRL
        return `R$ ${formattedValue}`;
      case 5: // SGD
        return `S$ ${formattedValue}`;
      case 6: // CHF
        return `CHF ${formattedValue}`;
      case 7: // CNY
        return `¥${formattedValue}`;
      case 8: // SEK
        return `${formattedValue} kr`;
      default:
        return `$${formattedValue}`;
    }
  }
};
